module.exports = __webpack_public_path__ + "static/scale-model-of-children's-museum-yunker-farm-in-fargo-north-dakota-550f4e6f2626389d4e52511a6925ab6f.png";